import { render, staticRenderFns } from "./LoaderLogo.vue?vue&type=template&id=46c594c6&"
import script from "./LoaderLogo.vue?vue&type=script&lang=js&"
export * from "./LoaderLogo.vue?vue&type=script&lang=js&"
import style0 from "./LoaderLogo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports